module.exports = "/static/assets/3d0c90aed47604658ef997be8e55f59c.png";